import React from 'react';
import { Modal } from '@vectord/components';

import { CreateLectureContentForm } from 'features/classCreation';

export default function CreateLectureContentModal({
  isOpen,
  title,
  contentType,
  handleClose,
  academyTopicId,
}) {
  return (
    <Modal
      isOpen={isOpen}
      size="large"
      title={title}
      unMountOnClose
      onClose={handleClose}
    >
      <CreateLectureContentForm
        contentType={contentType}
        label={title}
        onSuccess={handleClose}
        academyTopicId={academyTopicId}
      />
    </Modal>
  );
}
